import { Injectable } from '@angular/core';
import _ from 'lodash';
import { environment } from 'environments/environment';
import { APP_SETTINGS } from '../settings';
import notify from 'devextreme/ui/notify';

declare function require(moduleName: string): any;
const { version: appVersion } = require('../../../package.json');

@Injectable()
export class AppInformationService {
    config: any;
    clientVersion: string;
    serviceVersion: any;
    versionWarning: any;
    applicationInfo: any;
    serviceName = environment.serviceName;
    isLoggedIn = false;
    title: string;
    pleaseWait = false;

    private initVersionCheckEvent = new Event('initVersionCheck');

    constructor() {
        this.clientVersion = appVersion;

        document.addEventListener('setAppInfoServiceVersion', (args: any) => {
            if (args && args.detail && args.detail.serviceVersion) {
                this.serviceVersion = args.detail.serviceVersion;
                document.dispatchEvent(this.initVersionCheckEvent);
            }
        });
    }
    public get appTitle() {
        return 'Brewers City Dock';
    }

    get settings() {
        return APP_SETTINGS;
    }

    async pleaseWaitShow() {
        await Promise.resolve(null);
        this.pleaseWait = true;
    }

    async pleaseWaitHide() {
        await Promise.resolve(null);
        this.pleaseWait = false;
    }

    notifyToast(message: string, type: 'info' | 'warning' | 'error' | 'success' = 'success', displayTime = 3000) {
        notify({
            position: { my: 'center top', at: 'center top', offset: '0 90', of: 'body' },
            // position: { my: 'center top', at: 'right bottom', offset: '0 0', of: '.page-main' },
            message,
            closeOnClick: true,
            displayTime,
            width: '300px',
            type
        });
    }
}
